// comparison of wind speen in directions
import React, { Component, useState } from 'react'
import Chart from "react-apexcharts";
// import { Pricing } from './pages';



function App(){
  // pm1 vs timesnap 
	const [state , setState] = useState( {
    options: {
      chart: {
        id: "basic-bar"
      },
      xaxis: {
        categories: ["east" , "southeast" , "south" , "southwest"  , "west" , "northwest" , "north" ,  "northeast" ]
    }
    },
    series: [
      {
        // first series initialization
        name: "series PM-1",
        data: [33,25,26,28,22,32,16,26]    
        },
    ]
    
  })
// initializing app 
	return (
		<div className="my-app">
			<h1> Most Windy Days Of The Week In </h1>
			<div className="row">
        <div className="col-4">
        <Chart
            options={state.options}
            series={state.series}
            type="bar"
             width="1000"
           />
        </div>
			</div>
		</div>
		);

	}

  export default App;